module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": "top-start",
      "content": _vm.text,
      "popper-class": "tooltip-width"
    }
  }, [_c('span', {
    staticClass: "tooltip-text",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2c09496"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/tooltip/index.vue
// module id = 1471
// module chunks = 116